export class AreaRequestpecModel {
  public email: string;
  public notes: string;
}
